import React from "react";
import { Row, Col } from "react-bootstrap";
import CitizenComplaintSummary from "./ComplaintSummary";
import ServiceSummary from "./ServiceSummary";

const ComplaintSummaryPanel = ({ wards, citizenData, serviceData }) => (
  <Row className="g-3 mb-0 pd-complaint-row">
    <Col lg={6}>
      <CitizenComplaintSummary wards={wards} data={citizenData} />
    </Col>
    <Col lg={6}>
      <ServiceSummary wards={wards} data={serviceData} />
    </Col>
  </Row>
);

export default ComplaintSummaryPanel;
